import { gql } from "@apollo/client";

const schema = {
  get: {
    name: "users",
    serviceName: "unitadmin",
    query: gql`
      query users($ids: [String]) {
        users(ids: $ids) {
          data {
            email
            gender
            is_active
            lastname
            firstname
            birth_date
            national_code
          }
        }
      }
    `,
  },
  update: {
    name: "updateUser",
    serviceName: "unitadmin",
    query: gql`
      mutation updateUser(
        $ids: [String]!
        $gender: Int
        $is_active: Int
        $email: String
        $lastname: String
        $firstname: String
        $birth_date: String
        $national_code: String
      ) {
        updateUser(
          ids: $ids
          gender: $gender
          is_active: $is_active
          email: $email
          lastname: $lastname
          firstname: $firstname
          birth_date: $birth_date
          national_code: $national_code
        ) {
          messages
          model {
            lastname
            firstname
            cellphone
            media {
              id
              full_url
              collection_name
            }
          }
        }
      }
    `,
  },
};

export default schema;
